module.exports = __webpack_public_path__ + "img/card.90c9d85d.png";